<!--Instructions-->
<div class="InfoDiv">
	<h4 style="text-align: center">Instructions</h4>
	<div>
		<ul>
			<li>Enter Parent Information (Name and Email)</li>
			<li>Select students to assign to them</li>
			<li>Generate a QR code or send it in an email</li>
		</ul>
	</div>
</div>

<!--Parent Info-->
<div>
	<h4>Parent Info:</h4>
	<div>
		<label>Name:</label>
		<input type="form-control" [(ngModel)]="Name" />

		<label>Email:</label>
		<input type="form-control" [(ngModel)]="Email" />
	</div>
</div>

<!--Select Students-->
<div></div>

<!--Table of Students-->
<div></div>
